import React, { useId } from "react";
import { useLanguage } from "../context/LanguageContext";

export default function LanguageSwitcher({ dark = true, style = {}, testIdPrefix }) {
  const instanceId = useId().replace(/[^a-zA-Z0-9]/g, "");
  const { lang, changeLang } = useLanguage();
  const LANGS = ["ru", "kz", "en"];

  return (
    <div style={{ display: "flex", gap: "4px", ...style }}>
      {LANGS.map(l => (
        <button key={l} type="button" data-testid={`${testIdPrefix || `language-${instanceId}`}-${l}`}
          aria-label={l === "ru" ? "Русский" : l === "kz" ? "Қазақша" : "English"}
          aria-pressed={l === lang} onClick={() => changeLang(l)}
          style={{
            padding: "5px 9px", borderRadius: "3px", cursor: "pointer",
            fontFamily: "Manrope", fontSize: "10px", fontWeight: l === lang ? 700 : 400,
            textTransform: "uppercase", letterSpacing: "0.08em",
            transition: "all 0.2s",
            border: `1px solid ${l === lang ? "var(--ang-gold)" : (dark ? "var(--ang-border-strong)" : "rgba(0,0,0,0.15)")}`,
            background: l === lang ? "var(--ang-gold-soft)" : "transparent",
            color: l === lang ? "var(--ang-gold)" : (dark ? "var(--ang-text-faint)" : "rgba(0,0,0,0.4)")
          }}>
          {l}
        </button>
      ))}
    </div>
  );
}
